export default __webpack_public_path__ + "static/media/duplicate.111a95e2.svg";